import { useMemo } from "react";
import dayjs from "dayjs";
import { shifts, days } from "../helpers";

export function useInitialDates(dates) {
	return useMemo(() => {
		if (!Array.isArray(dates) || dates.length === 0) return [];

		return shifts.map((shift) => {
			const shiftDays = days.map((dayAbbr) => {
				const hasMatch = dates.some((entry) => {
					const date = dayjs(entry.day, "DD-MM-YYYY");
					const weekday = date.isValid() ? date.format("dd").toLowerCase() : null;

					return (
						weekday === dayAbbr &&
						entry.data?.[shift] !== undefined &&
						entry.data?.[shift]?.status == "Openstaand"
					);
				});

				return {
					name: dayAbbr,
					hasDays: hasMatch,
					isSelected: dates.some((entry) => {
						const date = dayjs(entry.day, "DD-MM-YYYY");
						const weekday = date.isValid() ? date.format("dd").toLowerCase() : null;

						return (
							weekday === dayAbbr &&
							entry.data?.[shift] !== undefined &&
							entry.data[shift].isSelected === true
						);
					}),
				};
			});

			return {
				shift,
				days: shiftDays,
			};
		});
	}, [dates]);
}
